import React, { Component, ErrorInfo, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

interface ErrorFallbackProps {
  onReload: () => void;
}

const ErrorFallback: React.FC<ErrorFallbackProps> = ({ onReload }) => {
  const { t } = useTranslation();

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      fontFamily: 'sans-serif',
      textAlign: 'center',
      padding: '20px',
      backgroundColor: 'var(--color-darkest)',
      color: 'var(--color-accent)'
    }}>
      <h1 style={{ fontSize: '2rem', marginBottom: '16px' }}>{t('common.errorTitle')}</h1>
      <p style={{ color: 'var(--color-primary)', marginBottom: '24px' }}>
        {t('common.errorMessage')}
      </p>
      <button
        onClick={onReload}
        style={{
          padding: '12px 24px',
          fontSize: '1rem',
          backgroundColor: 'var(--color-primary)',
          color: 'var(--color-darkest)',
          border: 'none',
          borderRadius: '8px',
          cursor: 'pointer',
          fontWeight: 'bold'
        }}
      >
        {t('common.reloadHome')}
      </button>
    </div>
  );
};

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_: Error): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('[ErrorBoundary] Error capturado:', error, errorInfo);
  }

  handleReload = () => {
    this.setState({ hasError: false });
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      return <ErrorFallback onReload={this.handleReload} />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
